// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3IESY","modalFooterButton":"ModalNotes_modalFooterButton__23DUR"};